import React, { useEffect, useMemo } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';

import { prettyFormatE164Number } from 'flow/utils/call-utils';
import { extractName } from 'flow/utils';

import useAppContext from 'flow/hooks/useAppContext';
import { makeGetContactDataForNumber } from 'flow/selectors/contact-selectors';
import { selectUserCountryCode } from 'flow/selectors/ExtensionSelectors';

import { lookupNumber } from 'flow/actions/contact-actions';
import SupervisorCallPopover from './SupervisorCallPopover';

interface Props {
    number: string;
    timestamp: number;
    queueName: string;
    inConfirmedCall: boolean;
}

export const SupervisorAgentCallPopover = ({
    number,
    timestamp,
    queueName,
    inConfirmedCall,
}: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const ownCountryCode = useAppSelector(selectUserCountryCode);

    const getContact = useMemo(makeGetContactDataForNumber, []);
    //@ts-ignore
    const contact = useAppSelector((state) => getContact(state, number));

    useEffect(() => {
        if (number && !contact) {
            dispatch(lookupNumber(number));
        }
    }, [dispatch, number, contact]);

    const iconId = inConfirmedCall ? 'phone_in_talk' : 'timer';

    const getTitle = () => {
        return prettyFormatE164Number(number, ownCountryCode);
    };

    const getSubtitle = () => {
        return extractName(contact, i18next.t('Contact.Unknown'));
    };

    return (
        <SupervisorCallPopover
            title={getTitle()}
            subtitle={getSubtitle()}
            timestamp={timestamp}
            iconKey={iconId}
            queueName={queueName}
        />
    );
};
